import _ from 'lodash';
import AppRestService from './app-rest.service';

/**
 * Service Endpoint Implementation
 */
export default class AuthService extends AppRestService {

  constructor(opts = null) {
    super(opts);
    this.serviceName = 'auth';
    this.routePath = 'session';
    this.authEnabled = true;
  }

  async status(sessionId = null) {
    let params = sessionId? { sessionId }: null;
    let path = [this.routePath, '/profile'];
    return this.request.get(path, params, { auth: true });
  }

  async login(user, pass) {

    if (_.isEmpty(user)) { throw new Error('invalid username param'); }
    if (_.isEmpty(pass)) { throw new Error('invalid password param'); }

    let params = { user, pass };
    let path = [this.routePath, '/login'];
    return this.request.get(path, params, null);
  }
}


